import React from 'react';
import styled from 'styled-components';
import InfoText from './InfoText';
import theme from 'config/theme';
import { VerificationChannel } from 'models/mobileVerification';
const { colors } = theme;

interface ResendOtpLinksProps {
	onResendSubmit: (type: VerificationChannel) => void;
}

const ResendOtpLinks = ({ onResendSubmit }: ResendOtpLinksProps) => {
	return (
		<>
			<InfoText>Not receiving an OTP?</InfoText>
			<LinksContainer>
				<ResendLink onClick={() => onResendSubmit(VerificationChannel.WhatsApp)}>
					Resend with WhatsApp
				</ResendLink>
				<ResendLink onClick={() => onResendSubmit(VerificationChannel.SMS)}>
					Resend with SMS
				</ResendLink>
			</LinksContainer>
		</>
	);
};

export default ResendOtpLinks;

const ResendLink = styled.p`
	color: ${colors.darkTurquoise};
	text-decoration: underline;
	font-size: 14px;
	cursor: pointer;
	margin-bottom: 0px;
`;

const LinksContainer = styled.div`
	margin-top: -12px;
`;
